import { useEffect, useRef } from 'react';
import { useNavigationStack } from '@/contexts/NavigationStackContext';

/**
 * Hook to integrate browser back button with UI elements (dialogs, sheets, etc.)
 * Automatically pushes/removes entries from navigation stack based on open state
 */
export const useBackNavigation = (
  isOpen: boolean,
  onClose: () => void,
  type: 'dialog' | 'sheet' | 'sub-navigation' = 'dialog'
) => {
  const { push, remove } = useNavigationStack();
  
  // Store onClose in a ref to avoid dependency issues and prevent infinite loops
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (isOpen) {
      // Pass a stable function that reads from the ref
      const id = push({ 
        type, 
        onClose: () => onCloseRef.current() 
      });
      
      // Cleanup: remove from stack when component unmounts or closes
      return () => {
        remove(id);
      };
    }
  }, [isOpen, type, push, remove]);
};
